// Import the functions you need from the SDKs you need
import {
  confirmPasswordReset,
  getAuth,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  verifyPasswordResetCode,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { toast } from "react-toastify";
import ROUTEPATH from "../../routes/RoutePath";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyChlD74p93hRqJupy5BYtFzWmzG83U413M",
  authDomain: "ideaclip-app-dev.firebaseapp.com",
  databaseURL: "https://ideaclip-app-dev-default-rtdb.firebaseio.com",
  projectId: "ideaclip-app-dev",
  storageBucket: "ideaclip-app-dev.appspot.com",
  messagingSenderId: "785912708609",
  appId: "1:785912708609:web:8a09a0c328fc7b2fbc8a00",
  measurementId: "G-3GECXMS9EG",
};

const firebaseConfigProd = {
  apiKey: "AIzaSyD-Vw_M1LdzLfg7CuxcVKrUxdnnZSsVRQY",
  authDomain: "ideaclip-app.firebaseapp.com",
  databaseURL: "https://ideaclip-app-default-rtdb.firebaseio.com",
  projectId: "ideaclip-app",
  storageBucket: "ideaclip-app.appspot.com",
  messagingSenderId: "206566280190",
  appId: "1:206566280190:web:b5aeda7738b50ca2db0eaf",
  measurementId: "G-8WGH5VBHFR",
};

const firebaseConfigTest = {
  apiKey: "AIzaSyAbDXZJWNQYtXhwOFudKZKPcpvM8IEpNVw",
  authDomain: "ideaclip-app-test-56e4c.firebaseapp.com",
  databaseURL:
    "https://ideaclip-app-test-56e4c-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ideaclip-app-test-56e4c",
  storageBucket: "ideaclip-app-test-56e4c.appspot.com",
  messagingSenderId: "620741354549",
  appId: "1:620741354549:web:071d9a166bdf7361e37d7c",
  measurementId: "G-JEGFDR7Q02",
};

// Initialize Firebase

const getConfig = () => {
  switch (process.env.REACT_APP_ENV) {
    case "dev":
      return firebaseConfig;
    case "prod":
      return firebaseConfigProd;
    case "test":
      return firebaseConfigTest;
    default:
      return firebaseConfig;
  }
};
const app = initializeApp(getConfig());
export const db = getFirestore(app);
export const auth = getAuth(app);

export const logInWithEmailAndPassword = async (email, password) => {
  try {
    const res = await signInWithEmailAndPassword(auth, email, password);

    return res;
  } catch (err) {
    return err;
  }
};
export const sendPasswordReset = async (email, navigate) => {
  try {
    await sendPasswordResetEmail(auth, email);
    toast.dismiss();
    toast.success("Password reset link sent!");
    navigate(ROUTEPATH.AUTH.LOGIN);
  } catch (err) {
    toast.dismiss();
    toast.error(
      "Sorry ! We couldn't find an account associated with the given email.",
    );
  }
};
export const resetPasswordHandler = async (code, newPassword, navigate) => {
  await verifyPasswordResetCode(auth, code)
    .then(() => {
      confirmPasswordReset(auth, code, newPassword)
        .then(() => {
          toast.success(
            "Password reset successfully. Login with your new password",
          );
          navigate("/auth/login");
        })
        .catch(() => {
          toast.error("Something went wrong!");
        });
    })
    .catch(() => {
      toast.error("Invalid Code!");
    });
};

export default app;
